import Store from "helpers/store";
import useStore from "hooks/useStore";
import { useCallback, useMemo } from "react";

import ChatService from "services/chat";

const chatStore = new Store({
  isVisible: false,
  messages: [],
  waitingForResponse: false,
  historyLoaded: false,
});

const useChat = () => {
  const service = useMemo(() => new ChatService(), []);

  const { get: getChat, set: setChat } = useStore(chatStore);
  const chat = getChat();

  const show = useCallback(() => {
    setChat((state) => ({ ...state, isVisible: true }));
  }, [setChat]);

  const hide = useCallback(() => {
    setChat((state) => ({ ...state, isVisible: false }));
  }, [setChat]);

  const addResponse = useCallback((answer) => {
    setChat((state) => ({
      ...state,
      messages: [...state.messages, {
        messageBody: answer,
        createdAt: new Date().getTime(),
        isResponse: true,
      }],
      waitingForResponse: false,
    }));
  }, [setChat]);

  const loadHistory = useCallback(() => {
    if (chat.historyLoaded) {
      return;
    }

    setChat({
      ...chat,
      historyLoaded: true,
    });

    service.getHistory()
      .then((data) => {
        if (!data || !Array.isArray(data.response)) return;
        setChat((state) => ({
          ...state,
          messages: data.response,
        }))
      })
      .catch(err => {
        console.error(err)
      });
  }, [chat, service, setChat]);

  const askQuestion = useCallback(async (question) => {
    if (chat.waitingForResponse) {
      return;
    }

    setChat((state) => ({
      ...state,
      messages: [
        ...state.messages,
        {
          messageBody: question,
          createdAt: new Date().getTime(),
          isResponse: false,
        }
      ],
      waitingForResponse: true,
    }));

    try {
      const gpt = await service.askGPT({ query: question });
      const answer = gpt.response;
      addResponse(answer);
    } catch (error) {
      // something went wrong
      console.log('ChatError: ', error);
      addResponse('Something went wrong! Please ask your question again.')
    }

  }, [setChat, addResponse, service, chat]);

  return {
    show,
    hide,
    askQuestion,
    loadHistory,
    ...chat,
  };
};

export default useChat;